import { defineCustomElement, getAttribute, getLiteralAttribute, NectaryElement, updateAttribute, updateLiteralAttribute } from '../utils';
import { DEFAULT_SIZE, sizeValues } from '../utils/size';
const templateHTML = '<style>:host{display:inline-block;vertical-align:middle;outline:0}#wrapper{position:relative;width:var(--sinch-local-size);height:var(--sinch-local-size);background-color:var(--sinch-comp-avatar-border-color-default-initial);border-radius:var(--sinch-comp-avatar-shape-radius);--sinch-local-size:var(--sinch-comp-avatar-size-m)}:host([size="l"]) #wrapper{--sinch-local-size:var(--sinch-comp-avatar-size-l)}:host([size="s"]) #wrapper{--sinch-local-size:var(--sinch-comp-avatar-size-s)}#text{display:block;width:100%;height:100%;font:var(--sinch-comp-avatar-container-font-size-m-text);line-height:calc(var(--sinch-local-size) - 2px);text-transform:uppercase;text-align:center}:host([size="l"]) #text{font:var(--sinch-comp-avatar-container-font-size-l-text);line-height:calc(var(--sinch-local-size) - 2px)}:host([size="s"]) #text{font:var(--sinch-comp-avatar-container-font-size-s-text);line-height:calc(var(--sinch-local-size) - 2px)}#circle{position:relative;width:calc(100% - 2px);height:calc(100% - 2px);left:1px;top:1px;border-radius:50%;-webkit-mask:linear-gradient(#fff,#000);mask:linear-gradient(#fff,#000);background-color:var(--sinch-comp-avatar-container-color-default-background);color:var(--sinch-comp-avatar-container-color-default-foreground)}#image{display:none;position:absolute;left:0;top:0;width:100%;height:100%;object-fit:contain}:host([src]:not([src=""])) #image{display:block}#person{display:none;position:absolute;left:0;top:0;width:100%;height:100%;fill:var(--sinch-comp-avatar-container-color-default-foreground);opacity:.15}:host(:not([src]):is(:not([alt]),[alt=""])) #person{display:block}#status-wrapper{position:absolute;left:calc(85% - 5px);top:calc(85% - 5px);width:10px;height:10px;padding:1px;box-sizing:border-box;border-radius:50%;background-color:var(--sinch-comp-avatar-border-color-default-initial);display:none;pointer-events:none}#status{width:8px;height:8px;border-radius:50%}:host([status=away]) #status-wrapper,:host([status=busy]) #status-wrapper,:host([status=offline]) #status-wrapper,:host([status=online]) #status-wrapper{display:block}:host([status=online]) #status{background-color:var(--sinch-comp-avatar-status-color-online-default-background)}:host([status=away]) #status{background-color:var(--sinch-comp-avatar-status-color-away-default-background)}:host([status=busy]) #status{background-color:var(--sinch-comp-avatar-status-color-busy-default-background)}:host([status=offline]) #status{background-color:var(--sinch-comp-avatar-status-color-offline-default-background)}</style><div id="wrapper"><div id="circle"><span id="text"></span><img id="image" alt=""/><svg id="person" viewBox="0 0 40 40" fill="none"><path d="M29.451 15.785a9.451 9.451 0 1 1-18.902 0 9.452 9.452 0 0 1 18.902 0ZM4.734 40.5c.119-7.085 5.899-12.792 13.012-12.792h4.508c7.113 0 12.893 5.707 13.012 12.792H4.734Z"/></svg></div><div id="status-wrapper"><div id="status"></div></div></div>';
import { getAvatarColorBg, getAvatarColorFg, statusValues } from './utils';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-avatar', class extends NectaryElement {
  #$circle;
  #$text;
  #$image;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$circle = shadowRoot.querySelector('#circle');
    this.#$text = shadowRoot.querySelector('#text');
    this.#$image = shadowRoot.querySelector('#image');
  }
  connectedCallback() {
    super.connectedCallback();
    this.#updateColor();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  static get observedAttributes() {
    return ['alt', 'src', 'color'];
  }
  attributeChangedCallback(name, _, newVal) {
    switch (name) {
      case 'alt':
        {
          this.#$text.textContent = newVal;
          this.#$image.alt = newVal ?? '';
          break;
        }
      case 'src':
        {
          this.#$image.src = newVal ?? '';
          break;
        }
      case 'color':
        {
          this.#updateColor();
          break;
        }
    }
  }
  get src() {
    return getAttribute(this, 'src');
  }
  set src(value) {
    updateAttribute(this, 'src', value);
  }
  get alt() {
    return getAttribute(this, 'alt', '');
  }
  set alt(value) {
    updateAttribute(this, 'alt', value);
  }
  get color() {
    return getAttribute(this, 'color');
  }
  set color(value) {
    updateAttribute(this, 'color', value);
  }
  get size() {
    return getLiteralAttribute(this, sizeValues, 'size', DEFAULT_SIZE);
  }
  set size(value) {
    updateLiteralAttribute(this, sizeValues, 'size', value);
  }
  get status() {
    return getLiteralAttribute(this, statusValues, 'status', null);
  }
  set status(value) {
    updateLiteralAttribute(this, statusValues, 'status', value);
  }
  #updateColor() {
    if (!this.isDomConnected) {
      return;
    }
    const colorName = this.color;
    if (colorName !== null && colorName.length > 0) {
      const bg = getAvatarColorBg(colorName);
      const fg = getAvatarColorFg(colorName);
      this.#$circle.style.setProperty('background-color', bg);
      this.#$circle.style.setProperty('color', fg);
    } else {
      this.#$circle.style.removeProperty('background-color');
      this.#$circle.style.removeProperty('color');
    }
  }
});